// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';
import Stripe                   from 'stripe';

// ===== Enums =====

import {
    STRIPE_PAYMENT_INTENT_UPDATE_MODE_TYPE,
}                               from '../enums';

// ===== Interfaces =====

import {
    IAddress,
    ICartItem,
    IShippoRateObject,
    IBookInvite,
}                               from '../interfaces';

const stripeUpdatePaymentIntent = async ({
    test,
    paymentIntentId,
    updateMode,
    cartItems,
    customerId,
    paymentMethodId,
    userEmail,
    mailingAddress,
    billingAddress,
    shippingRate,
    promotionIds,
    addToMailingList,
    savePaymentMethod,
    trackingNumber,
    hadComplimentaryBookInviteAtCheckout,
    bookInviteAssignOneToSelf,
    bookInvites,
}: {
    test: boolean,
    paymentIntentId: string,
    updateMode?: STRIPE_PAYMENT_INTENT_UPDATE_MODE_TYPE,
    cartItems?: ICartItem[],
    customerId?: string,
    paymentMethodId?: string | null,
    userEmail?: string,
    mailingAddress?: IAddress,
    billingAddress?: IAddress,
    shippingRate?: IShippoRateObject,
    promotionIds?: string[],
    addToMailingList?: boolean,
    savePaymentMethod?: boolean,
    trackingNumber?: string,
    hadComplimentaryBookInviteAtCheckout?: boolean,
    bookInviteAssignOneToSelf?: boolean,
    bookInvites?: IBookInvite[],
}): Promise<Stripe.PaymentIntent> => {
    const functions = getFunctions();
    const updatePaymentIntent = httpsCallable<
        Record<
            string,
            boolean | string | IAddress | IShippoRateObject | string[] | ICartItem[] | IBookInvite[]
        >,
        Stripe.PaymentIntent
    >(
        functions,
        'stripeUpdatePaymentIntent',
    );

    const args: Record<
        string,
        boolean | string | IAddress | IShippoRateObject | string[] | ICartItem[] | IBookInvite[]
    > = {
        test,
        paymentIntentId,
    };
    if (updateMode) args.updateMode = updateMode;
    if (cartItems) args.cartItems = [...cartItems];
    if (customerId) args.customerId = customerId;
    if (paymentMethodId) args.paymentMethodId = paymentMethodId;
    if (userEmail) args.userEmail = userEmail;
    if (mailingAddress) args.mailingAddress = mailingAddress;
    if (billingAddress) args.billingAddress = billingAddress;
    if (shippingRate) args.shippingRate = shippingRate;
    if (promotionIds) args.promotionIds = [...promotionIds];
    if (addToMailingList) args.addToMailingList = addToMailingList;
    if (savePaymentMethod) args.savePaymentMethod = savePaymentMethod;
    if (trackingNumber) args.trackingNumber = trackingNumber;
    if (hadComplimentaryBookInviteAtCheckout !== undefined) {
        args.hadComplimentaryBookInviteAtCheckout = hadComplimentaryBookInviteAtCheckout;
    }
    if (bookInviteAssignOneToSelf != null) {
        args.bookInviteAssignOneToSelf = bookInviteAssignOneToSelf;
    }
    if (bookInvites != null) {
        args.bookInvites = bookInvites;
    }

    return updatePaymentIntent(args).then((result) => {
        const paymentIntent = result.data as Stripe.PaymentIntent;
        return paymentIntent;
    }).catch((err) => {
        throw err;
    });
};

export default stripeUpdatePaymentIntent;
